export const scrollToTop = () => {
    const btn = document.getElementById('scrollToTop');
    if (!btn) return;

    const showAfter = 1000; // px rolados para aparecer

    // mostrar/ocultar com listener de scroll (passive para performance)
    function toggleVisibility() {
        if (window.pageYOffset > showAfter) {
            btn.classList.add('show');
        } else {
            btn.classList.remove('show');
        }
    }

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    // run once on load
    toggleVisibility();

    // animação de scroll com fallback
    function smoothScrollToTop() {
        // respeitar prefer-reduced-motion
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
            window.scrollTo(0, 0);
            return;
        }

        // se browser suporta smooth nativamente
        if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
        }

        // fallback simples: animação com requestAnimationFrame
        const start = window.pageYOffset;
        const duration = 420;
        let startTime = null;

        function step(timestamp) {
        if (!startTime) startTime = timestamp;
            const time = timestamp - startTime;
            const progress = Math.min(time / duration, 1);
            const ease = 1 - Math.pow(1 - progress, 3);

            window.scrollTo(0, Math.floor(start * (1 - ease)));

            if (time < duration) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    btn.addEventListener('click', function (e) {
        e.preventDefault();
        smoothScrollToTop();
        // garantia de acessibilidade: remove foco do botão depois do clique
        btn.blur();
    });

    // opcional: mostrar se o botão receber foco por teclado
    btn.addEventListener('focus', function () {
        if (!btn.classList.contains('show')) btn.classList.add('show');
    });

    btn.addEventListener('blur', function () {
        // se a página estiver no topo, escondemos novamente
        if (window.pageYOffset <= showAfter) btn.classList.remove('show');
    });
};